import React, { FC, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Avatar, ButtonContainer } from '../../jsxElements';
import styles from './CareWrapper.module.css';
import sharedStyles from '../../shared.module.css';

import { AmpFlagSet } from '../../amplitude';

export const CareWrapper: FC<{
    cardContent: any;
    disableButtons: boolean;
    featureFlags: AmpFlagSet;
    loading: boolean;
    returnDescription?: string;
    returnText?: string;
    sendMessage: (message: string) => void;
}> = ({
    disableButtons,
    cardContent,
    featureFlags,
    loading,
    returnDescription,
    returnText,
    sendMessage,
}) => {
    const navRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (navRef && navRef.current && !loading) {
            navRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        }
    }, [loading]);

    return (
        <div className={styles.careWrapperChatBubbleContainer} ref={navRef}>
            {!loading ? (
                <>
                    {cardContent}
                    {returnText && (
                        <div
                            className={classNames(
                                sharedStyles.botMessageContainer,
                                styles.careWrapperBubbleExtra
                            )}
                        >
                            <div className={sharedStyles.botMessageAvatar}>
                                <Avatar />
                            </div>
                            <div
                                className={classNames(
                                    sharedStyles.botMessageBubble,
                                    styles.careWrapperBubbleContainer
                                )}
                            >
                                <>
                                    <p
                                        className={
                                            styles.careWrapperReturnDescription
                                        }
                                    >
                                        {returnDescription}
                                    </p>
                                    <ButtonContainer
                                        buttons={[
                                            {
                                                // return to main menu button
                                                button: { title: returnText },
                                                disableButtons,
                                                featureFlags,
                                                index: 1,
                                                sendMessage,
                                            },
                                        ]}
                                        featureFlags={featureFlags}
                                    />
                                </>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className={sharedStyles.ellipsis}>{'\u2026'}</div>
            )}
        </div>
    );
};

export default CareWrapper;
